import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { AddressViewComponent } from '@shared/components/address-view/address-view.component';
import { FieldsetAriaFixDirective } from '@shared/directives/fieldset-area-fix.directive';
import { FieldsetModule } from 'primeng/fieldset';

@Component({
  selector: 'app-data-checkbox-wrapper',
  templateUrl: './data-checkbox-wrapper.component.html',
  styleUrls: ['./data-checkbox-wrapper.component.scss'],
  imports: [FieldsetModule, FieldsetAriaFixDirective, CommonModule, AddressViewComponent]
})
export class DataCheckboxWrapperComponent extends FieldWrapper{

  constructor() {
    super();
  }

  public executeCallback(event, callback) {
    event.preventDefault();
    callback();
  }


}
